import { render } from "./AlertBanner.vue?vue&type=template&id=6a32d9c7&scoped=true"
import script from "./AlertBanner.vue?vue&type=script&lang=ts"
export * from "./AlertBanner.vue?vue&type=script&lang=ts"

import "./AlertBanner.vue?vue&type=style&index=0&id=6a32d9c7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a32d9c7"

export default script